import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const ProfileContext = createContext(null);

export function ProfileProvider({ children }) {
  const { user, isAuthenticated } = useAuth();
  const [profile, setProfile] = useState(null);
  const [completed, setCompleted] = useState(null); // null=unknown, true, false
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!isAuthenticated) {
      setProfile(null);
      setCompleted(null);
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.get("/profile/me");
      setProfile(data.profile || null);
      setCompleted(!!data.profile_completed);
    } catch {
      setProfile(null);
      setCompleted(false);
    } finally {
      setLoading(false);
    }
  }, [isAuthenticated]);

  useEffect(() => {
    refresh();
  }, [refresh, user?.id]);

  const value = useMemo(
    () => ({ profile, completed, loading, refresh, setProfile, setCompleted }),
    [profile, completed, loading, refresh]
  );

  return <ProfileContext.Provider value={value}>{children}</ProfileContext.Provider>;
}

export function useProfile() {
  const ctx = useContext(ProfileContext);
  if (!ctx) throw new Error("useProfile must be used within ProfileProvider");
  return ctx;
}
